// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2f7dD","actionsContainer":"styles_actionsContainer__3qwnR"};